import React from 'react';

const DownloadCSV = ({ data, fileName, headers }) => {
  const convertToCSV = (objArray) => {
    const array = typeof objArray !== 'object' ? JSON.parse(objArray) : objArray;
    let str = '';

    // Add header row
    if (headers && headers.length) {
      str += headers.join(',') + '\r\n';
    }

    for (let i = 0; i < array.length; i++) {
      let line = '';
      for (let index in array[i]) {
        if (line !== '') line += ',';

        line += array[i][index];
      }
      str += line + '\r\n';
    }
    return str;
  };

  const downloadCSV = () => {
    const csvData = new Blob([convertToCSV(data)], { type: 'text/csv;charset=utf-8' });
    const csvURL = URL.createObjectURL(csvData);
    const link = document.createElement('a');
    link.href = csvURL;
    link.download = `${fileName}.csv`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <>
      <style>
            {`
                .style-export {
                    position: absolute !important;
                    top: 0 !important;
                    right: 0 !important;
                    margin-top: 25px !important;
                    margin-right: 10px !important;
                }
            `}
        </style>
        <button className="btn-create style-export" onClick={downloadCSV}>
            <img src='assets/icons/ic-export.png' alt='export' className="ic-style01 me-2"/>
            Export
        </button>
    </>
    
  );
}

export default DownloadCSV;